import faImage from "../assets/img/keys/active/head-fa-front.png";
import faBackImage from "../assets/img/keys/active/head-fa-back.png";
import ovImage from "../assets/img/keys/active/head-ov-front.png";
import ovBackImage from "../assets/img/keys/active/head-ov-back.png";
import fLAFront from "../assets/img/keys/active/profile-fla-front.png";
import flaBack from "../assets/img/keys/active/profile-fla-back.png";
import bohrMuldenFront from "../assets/img/keys/active/profile-bohrmulden-front.png";
import bohrMuldenBack from "../assets/img/keys/active/profile-bohrmulden-back.png";

import { IKeysBlankNames } from "../constants/pragerohlinge";
import { ORIGINAL_KEY_IMAGES } from "../constants/generateImage";
import { IKeySideName } from "../store/keysTypes";

interface IProps {
  blank: string;
  profile: string;
  side?: string;
  customization?: "configuration" | "summary";
}

const BOHRMULDEN_PROFILES: string[] = [
  "abu-91fa",
  "basi-bmfa",
  "basi-vbfa",
  "ci-48fa",
];

const getKeyImage = ({
  profile,
  blank,
  side,
  customization = "configuration",
}: IProps) => {
  if (profile === "flafa") {
    return {
      image: side === IKeySideName.BACK ? flaBack : fLAFront,
    };
  }

  if (
    customization !== "configuration" &&
    BOHRMULDEN_PROFILES.includes(profile)
  ) {
    return {
      image: side === IKeySideName.BACK ? bohrMuldenBack : bohrMuldenFront,
    };
  }

  if (blank === IKeysBlankNames.FA) {
    return {
      image: side === IKeySideName.BACK ? faBackImage : faImage,
    };
  }

  if (blank === IKeysBlankNames.OV) {
    return {
      image: side === IKeySideName.BACK ? ovBackImage : ovImage,
    };
  }

  return {
    image:
      ORIGINAL_KEY_IMAGES[profile][side as "front" | "back"] ||
      ORIGINAL_KEY_IMAGES.abu17d.front,
  };
};

export default getKeyImage;
